<template>
  <div class="content">
    <div class="list-box" v-for="(item, index) in bodyList" :key="index">
      <h1>{{ item.new1 }}</h1>
      <div class="text">
        <h2>{{ item.new2 }}</h2>
        <p><span v-if="item.new3">质控标准：</span>{{ item.new3 }}</p>
      </div>
    </div>
    <!-- <div class="list">
      <div class="head">
        <span v-for="(item, index) in headList" :key="index">
          <template v-if="item.field != 'new2'">
            {{ item.title }}
          </template>
          <template v-else> 数值 </template>
        </span>
        <span>数值</span>
        <span>质控标准</span>
      </div>
      <div class="show-box" v-if="open"></div>
      <div class="contentTab" v-for="(item, index) in bodyList" :key="index">
        <span class="wspan">{{ item.new1 }}</span>
        <span style="color: #27ca8d">{{ item.new2 }}</span>
        <span style="">{{ item.new3 }}</span>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    list: Array,
  },
  data() {
    return {
      open: false,
      headList: [],
      bodyList: [],
    };
  },
  watch: {
    list: function (val) {
      this.headList = val[0];
      this.bodyList = val[1];
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
  margin-bottom: 10px;
}
.content {
  //
    font-family: @family;

  padding: 10px 24px 1px;
  .list-box {
    border-bottom: 1px solid #e3e5e8;
    margin-bottom: 30px;
    padding-bottom: 20px;
    &:last-child {
      border: 0;
      margin: 0;
    }
    h1 {
      font-size: 15PX;
      font-weight: 500;
      color: #2f354d;
      line-height: 22px;
      position: relative;
      padding-left: 12px;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top:50%;
        margin-top: -7px;
        width: 3px;
        height: 14px;
        background: #2f354d;
        border-radius: 2px;
      }
    }
    .text {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 12px;
      h2 {
        font-size: 18PX;
        //
    font-family: @family;

        font-weight: 500;
        color: #27ca8d;
        line-height: 28px;
      }
      p {
        font-size: 13px;
        //
        font-weight: 400;
        color: #2f354d;
        line-height: 28px;
        span {
          font-size: 13px;
          font-weight: 400;
          color: #a4a9bf;
          line-height: 28px;
        }
      }
    }
  }
  .list {
    padding-bottom: 24px;
    .wspan {
      width: 50% !important;
      flex: none !important;
      padding-right: 20px;
      box-sizing: border-box;
    }
    .head {
      padding: 0 24px;
      font-size: 15PX;
      font-weight: 500;
      color: #9095a7;
      line-height: 48px;
      display: flex;

      span {
        width: 25%;
        &:first-child {
          width: 50%;
        }
      }
    }
    .contentTab {
      padding: 13px 24px;
      display: flex;
      font-size: 15PX;
      font-weight: 400;
      color: #2f354d;
      align-items: center;
      span {
        //
        width: 25%;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
